/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AdminOrPhysician,
  ErrorResponse,
  StaffRole,
} from '../models';
import {
    AdminOrPhysicianFromJSON,
    AdminOrPhysicianToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    StaffRoleFromJSON,
    StaffRoleToJSON,
} from '../models';

export interface CreateStaffRoleRequest {
    staffRole: StaffRole;
}

export interface GetStaffRolesRequest {
    includeInactive?: boolean;
}

export interface SearchStaffRequest {
    name?: string;
    clinicId?: string;
    limit?: number;
}

export interface UpdateStaffRoleRequest {
    id: string;
    staffRole: StaffRole;
}

/**
 * 
 */
export class StaffApi extends runtime.BaseAPI {

    /**
     * Create a staff role (Roles: admin)
     */
    async createStaffRoleRaw(requestParameters: CreateStaffRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StaffRole>> {
        if (requestParameters.staffRole === null || requestParameters.staffRole === undefined) {
            throw new runtime.RequiredError('StaffRole','Required parameter requestParameters.staffRole was null or undefined when calling createStaffRole.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/staff/roles`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: StaffRoleToJSON(requestParameters.staffRole),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StaffRoleFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    createStaffRoleRequestOptionsRaw(requestParameters: CreateStaffRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.staffRole === null || requestParameters.staffRole === undefined) {
            throw new runtime.RequiredError('StaffRole','Required parameter requestParameters.staffRole was null or undefined when calling createStaffRole.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/staff/roles`,
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: StaffRoleToJSON(requestParameters.staffRole),
        };
        return responseConfig
    }

    /**
     * Create a staff role (Roles: admin)
     */
    async createStaffRole(requestParameters: CreateStaffRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StaffRole> {
        const response = await this.createStaffRoleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get the tenant\'s staff roles (Roles: physician, admin)
     */
    async getStaffRolesRaw(requestParameters: GetStaffRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<StaffRole>>> {
        const queryParameters: any = {};

        if (requestParameters.includeInactive !== undefined) {
            queryParameters['includeInactive'] = requestParameters.includeInactive;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/staff/roles`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(StaffRoleFromJSON));
    }

    /**
        Request Config Getter
     */
    getStaffRolesRequestOptionsRaw(requestParameters: GetStaffRolesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        const queryParameters: any = {};

        if (requestParameters.includeInactive !== undefined) {
            queryParameters['includeInactive'] = requestParameters.includeInactive;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/staff/roles`,
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Get the tenant\'s staff roles (Roles: physician, admin)
     */
    async getStaffRoles(requestParameters: GetStaffRolesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<StaffRole>> {
        const response = await this.getStaffRolesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns staff members by name (Roles: physician, admin)
     */
    async searchStaffRaw(requestParameters: SearchStaffRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AdminOrPhysician>>> {
        const queryParameters: any = {};

        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }

        if (requestParameters.clinicId !== undefined) {
            queryParameters['clinicId'] = requestParameters.clinicId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/staff`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AdminOrPhysicianFromJSON));
    }

    /**
        Request Config Getter
     */
    searchStaffRequestOptionsRaw(requestParameters: SearchStaffRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        const queryParameters: any = {};

        if (requestParameters.name !== undefined) {
            queryParameters['name'] = requestParameters.name;
        }

        if (requestParameters.clinicId !== undefined) {
            queryParameters['clinicId'] = requestParameters.clinicId;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/staff`,
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Returns staff members by name (Roles: physician, admin)
     */
    async searchStaff(requestParameters: SearchStaffRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AdminOrPhysician>> {
        const response = await this.searchStaffRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Update a staff role (Roles: admin)
     */
    async updateStaffRoleRaw(requestParameters: UpdateStaffRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StaffRole>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateStaffRole.');
        }

        if (requestParameters.staffRole === null || requestParameters.staffRole === undefined) {
            throw new runtime.RequiredError('StaffRole','Required parameter requestParameters.staffRole was null or undefined when calling updateStaffRole.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/staff/roles/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: StaffRoleToJSON(requestParameters.staffRole),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StaffRoleFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    updateStaffRoleRequestOptionsRaw(requestParameters: UpdateStaffRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling updateStaffRole.');
        }

        if (requestParameters.staffRole === null || requestParameters.staffRole === undefined) {
            throw new runtime.RequiredError('StaffRole','Required parameter requestParameters.staffRole was null or undefined when calling updateStaffRole.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/staff/roles/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: StaffRoleToJSON(requestParameters.staffRole),
        };
        return responseConfig
    }

    /**
     * Update a staff role (Roles: admin)
     */
    async updateStaffRole(requestParameters: UpdateStaffRoleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StaffRole> {
        const response = await this.updateStaffRoleRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
